import { useState } from 'react';
import {
  Box, Button, Flex, Heading, Image, Input, Text
} from '@chakra-ui/react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useToastContext } from '../UI/ToastManager';

export function LoginForm({ onLogin }: { onLogin: (email: string, password: string) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { showSuccess, showError } = useToastContext();

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      showError('Login Failed', 'Please enter both username and password');
      return;
    }

    setError('');
    
    try {
      if (username && password) {
        setIsLoading(true);
        await onLogin(username, password);
        setIsLoading(false)
      }
    } catch {
      setIsLoading(false)
      setError('Invalid credentials');
      showError('Login Failed', 'Invalid username or password. Please try again.');

    }

    setIsLoading(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center">
      <Flex bg="white" p="44px" maxH="750px" rounded="lg" boxShadow="lg" maxW="600px" flexGrow={1}>
        <Flex direction="column" gap={6} flexGrow={1}>
          <Image src="/logo.png" alt="QONA" boxSize="90px" alignSelf="center" my="32px" />
          <Heading size="lg" textAlign="center">Sign in to your account</Heading>
          <Box mt="52px">
            <Text mb="10px" fontWeight="medium" fontSize="20px">Username or email</Text>
            <Input 
              value={username} 
              onChange={e => setUsername(e.target.value)} 
              placeholder="Name"
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />
          </Box>
          <Box>
            <Text mb="10px" fontWeight="medium" fontSize="20px">Password</Text>
            <Box position="relative">
              <Input
                pr="2.5rem"
                type={show ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                disabled={isLoading}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '15px',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#8b8b8b',
                }}
              >
                {show ? <FaEyeSlash /> : <FaEye />}
              </button>
            </Box>
          </Box>
          {error && <Text color="red.500">{error}</Text>}
          <Button 
            mt="10px" 
            h="48px" 
            mb="32px" 
            onClick={handleLogin}
            loading={isLoading}
            loadingText="Signing in..."
          >
            Sign in
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}